<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">Contact Details</h6>
    </b-col>
  </b-row>
  <div class="details-card">

    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_contactdetails.ContactPerson" @change="input"
            :label="$t('5005.contactdetails.contactperson')" name="Contact Person" id='Contact Person'
            :rules="{ required: true, alphabet: true }" :required-icon="true" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_contactdetails.ContactDesignation" @change="input"
            :label="$t('5005.contactdetails.designation')" name="Designation" id='Designation'
            :rules="{ alphabet: true }" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="insert_contactdetails.Phone" @change="input"
            :label="$t('5005.contactdetails.phone')" name="Phone Number" id='Phone Number'
            :rules="{ required: true, numeric: true }" :maxlength="10" :required-icon="true" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="insert_contactdetails.LaneLine" @change="input" label="LaneLine Number"
            name="LaneLine Number" id='LaneLine Number' :rules="{ required: true, numeric: true }" :maxlength="10"
            :required-icon="true" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_contactdetails.Email" @change="input" :label="$t('5005.contactdetails.email')"
            name="Email" id='Email' :rules="{ required: true, email: true }" :required-icon="true" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_contactdetails.Fax" @change="input" label="FAX" name="FAX" id='FAX'
            :rules="{ required: true, }" />
        </div>

      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput v-model="insert_contactdetails.Web" @change="input" :label="$t('5005.contactdetails.website')"
            name="WebSite" id='WebSite' :rules="{ website: true }" />
        </div>

      </b-col>
    </b-row>
  </div>

  <!-- </b-row> -->
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted } from "vue";

import TextInput from '../../../../components/FormComponents/TextInput.vue'
export default defineComponent({
  components: {
    TextInput
  },
  props: {
    value: {},
  },

  setup(props, { emit }) {


    const insert_contactdetails = reactive({
      ContactPerson: "",
      ContactDesignation: "",
      Phone: "",
      Email: "",
      Web: "",
      LaneLine: "",
      Fax: ""
    })

    onMounted(() => {
      Object.assign(insert_contactdetails, props.value)
      input()
    });
    function input() {
      console.log('test');
      emit('update:modelValue', insert_contactdetails)
    }

    return {
      input,
      insert_contactdetails
    };
  },

});
</script>
